//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.VehicleDesign.js";
import "../no/TaggedObject.js";
import "../no/Expression.js";
import "../no/Expression.js";
let d=[[[0,"CreateGeometry",1,0],[0,"PT15Left",1,"Point",0],[0,"PT15LeftFlag",1,0],[0,"PT15Right",1,"Point",0],[0,"PT15RightFlag",1,0],[0,"PT16Left",1,"Point",0],[0,"PT16LeftFlag",1,0],[0,"PT16Right",1,"Point",0],[0,"PT16RightFlag",1,0],[1,"ReqHorizontalLeftExact",0,"Expression",0],[1,"ReqHorizontalRightExact",0,"Expression",0],[1,"ReqVerticalMax",0,"Expression",0],[1,"ReqVerticalMin",0,"Expression",0],[0,"SR3FrtLeft",1,"Point",0],[0,"SR3FrtLeftFlag",1,0],[0,"SR3FrtRight",1,"Point",0],[0,"SR3FrtRightFlag",1,0],[0,"SR3Left",1,"Point",0],[0,"SR3LeftFlag",1,0],[1,"SR3Offset",0,"Expression",0],[0,"SR3Right",1,"Point",0],[0,"SR3RightFlag",1,0],[0,"SR3RrLeft",1,"Point",0],[0,"SR3RrLeftFlag",1,0],[0,"SR3RrRight",1,"Point",0],[0,"SR3RrRightFlag",1,0]],[[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.Features.VehicleDesign.HeadImpactOtherRailDetailBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.VehicleDesign.HeadImpactOtherRailDetailBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;